export type DaysToModifyTypes =
  | "user_day_off"
  | "global_day_off"
  | "selectable_global_day_off";

export interface DaysToModify {
  from: Date;
  to: Date;
  title: string;
  repeating: boolean;
  type?: DaysToModifyTypes;
}
